/*
 * WebCRD
 * Web to print solution that automates ordering, fulfillment, job ticketing, production management and chargebacks across corporate print centers.
 * Copyright 1999-2026 Rochester Software Associates (service@rocsoft.com)
 */

import MaterialIcon from '~/components/images/icons/MaterialIcon';
import { useSetRouteHelpKey } from '~components/header/help/HelpContext';
import UntitledPage from '~components/page/UntitledPage';
import Heading from '~components/text/Heading';
import LocalizedString from '~components/text/LocalizedString';
import useLocalizations from '~components/text/useLocalizations';

import usePathName from '../usePathName';

const TITLE_LOCALE_KEY = 'COMMON_UI.TITLE.PAGE_NOT_FOUND';
const BODY_LOCALE_KEY = 'COMMON_UI.MESSAGE.PAGE_NOT_FOUND';

export const useLocalizationPrefetch = () => {
    useLocalizations([TITLE_LOCALE_KEY, BODY_LOCALE_KEY]);
};

const PageNotFound = () => {
    const pathName = usePathName();
    useSetRouteHelpKey('PageNotFound');

    return (
        <UntitledPage>
            <div className="container containerError" data-path-name={pathName}>
                <MaterialIcon name="Search Off" size={150}/>
                <Heading level={1}>
                    <LocalizedString localeKey={TITLE_LOCALE_KEY} />
                </Heading>
                <p>
                    <LocalizedString localeKey={BODY_LOCALE_KEY} />
                </p>
            </div>
        </UntitledPage>
    );
};

export default PageNotFound;
